module.exports = __webpack_public_path__ + "static/img/13.26ad571.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/13.jpg
// module id = K2YE
// module chunks = 1